export default __webpack_public_path__ + "static/media/background-orange.09e16973.svg";